// TODO when app is in SPA state and we use router, replace this with a hook
import { route } from "../../shim/jsbridge";

const URL_SPLITTER = "/";

export const getPathParts = pathname =>
  (pathname ?? window.location?.pathname)?.split(URL_SPLITTER).filter(Boolean);

export const getHelpDropdownItems = () => [
  {
    label: "Open User Guide",
    href: "https://docs.reversinglabs.com/SpectraAnalyze/",
    title: "Open docs.reversinglabs.com",
    target: "_blank",
    className: "main-nav__item-link"
  },
  {
    label: "API Docs",
    href: route("swagger-ui"),
    title: "Spectra-Analyze-API-Docs",
    target: "_blank",
    className: "main-nav__item-link"
  },
  {
    label: "Contact Support",
    href: "mailto:support@reversinglabs.com",
    className: "main-nav__item-link"
  }
];

export const getUserDropdownItems = (isAdmin, isLocalLicenseValidOrOnline) => [
  {
    to: "/admin/",
    className: "main-nav__item-link",
    label: "Administration",
    visible: isAdmin && isLocalLicenseValidOrOnline,
    linkReloadsDocument: true
  },
  {
    to: route("user_profile"),
    className: "main-nav__item-link",
    label: "User Profile",
    visible: isLocalLicenseValidOrOnline,
    linkReloadsDocument: false
  },
  {
    to: route("logout_login"),
    className: "main-nav__item-link",
    label: "Log Out",
    visible: true,
    linkReloadsDocument: true
  }
];

export const formatHeaderAlertCount = totalCount => {
  if (totalCount > 9) {
    return "9+";
  } else {
    return totalCount;
  }
};
